import { render, staticRenderFns } from "./HowSection.vue?vue&type=template&id=4fc72095&"
import script from "./HowSection.vue?vue&type=script&lang=js&"
export * from "./HowSection.vue?vue&type=script&lang=js&"
import style0 from "./HowSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports